export default __webpack_public_path__ + "static/14-d799f5cb4f7d6d49536c38524af6b741.webp";